import { appConfig, headerConfig, refineHeader } from "../../config";

export const paymentSettingService = {
  savePaymentSetting,
  getPaymentSetting,
  getFrontPaymentSetting,
};

function savePaymentSetting(postData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: postData
  };

  return fetch(`${appConfig.api.url}payment/save-settings`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getPaymentSetting(postData) {
  refineHeader(); 
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}payment/getSettings`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getFrontPaymentSetting(postData) {
  refineHeader(); 
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}payment/getFrontSettings`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/paymentSettingService.js